import React, { useState, useContext, useEffect, useRef } from "react";
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import {Form, Col, Row, Tab, Tabs, Container, Modal} from "react-bootstrap";
import AddIcon from "@material-ui/icons/Add";
import {Select, MenuItem, Snackbar} from "@material-ui/core";
import { FormLabelStyle } from "../form/FormLabel";
import { RequestContext } from "../../context/RequestContext";
import { UserContext } from "../../context/UserContext";
import JobUtils from "../../utils/JobsUtils";
import Moment from "moment-timezone";
import SourceForm from "../source/SourceForm";
import Delivery from "../delivery/Delivery";
import Process from "../processing/Process";
import FormRequestSummary from "../modal/FormRequestSummary";
import AlertDialog from "../common/AlertDialog";
import { AlertMessage } from "../../constants/AlertMessage";
import EmailPopper from "../popper/EmailPopper";
import Source from "../source/Source";
import RequestUtils from "../../utils/RequestUtils";
import ProcessForm from "../processing/ProcessForm";
import DeliveryForm from "../delivery/DeliveryForm";
import { DoubleArrow } from "@material-ui/icons";
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import SourceDrag from "../drag-drop/SourceDrag";
import Stitch from "./Stitch";
import {
  StyledBlueButton,
  StyledDarkBlueButton
} from "../../styles/BootstrapStyles";
import "../../styles/form.scss";
import { ErrorMessages, Info,getAllowedMethod} from "../../constants/Text";
import ImportSources from "../source/ImportSources";
import Header from "../header/Header"; 
import {ReactComponent as CalendarIcon} from "../../assets/icons/calendar.svg";
import {JobTypes, ProcessorProfiles, SourceLocations, ScreenerTypes, RequestTypes, ScreenerEncryptionTypes} from "../../constants/Request";
import ConfigUtils from "../../utils/ConfigUtils"; 
import PopupModal from '../modal/PopupModal';
import CloseIcon from "@material-ui/icons/Close";
import { PERMITTED_ROLES } from "../../constants/UserRoles";

const inputPattern = /(^ *[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}) *?$/;
const isEditing = false;

const FormRequest = () => {
  const jobTypes = ConfigUtils.getJobTypes().filter(jobType => !jobType.hideFromUI);
  const {
    requestName,
    _setRequestName,
    dueDate,
    _setDueDate,
    dueTime,
    _setDueTime,
    jobType,
    status,
    _setJobType,
    sourceLocation,
    _setSourceLocation,
    hasInvalidAssets,
    contacts,
    _setContacts,
    notes,
    _setNotes,
    requestDraft,
    updateJob,
    sources,
    deliveriesToSourceMapping,
    _setUnMappedSources,
    showRequestForm,
    _setShowRequestForm,
    display,
    processes,
    _setShowSourceForm,
    showSourceForm,
    itemList,
    _setShowProcessForm,
    showProcessForm,
    _setShowDeliveryForm,
    showDeliveryForm,
    deliveries,
    updateProcess,
    addNewProcess,
    isStitch,
    stitchedKeys,
    setStitchingError,
    setIsStitch,
    stitchAssetName,
    setStitchAssetNameError,
    addNewSources,
    ecoProcessError,
    _setEcoProcessError,
    loadParameters,
    submitRequest,
    needContentProtection,
    contentProtection,
    _setUnmappedDeliveryKeys,
    type,
    premiereDateConfirmed,
    setPremiereDateConfirmed,
    dcpDateConfirmed,
    setDcpDateConfirmed,
    eventDeliveryFlag,
    setEventDeliveryFlag,
    importError,
    setImportError,
    enableSnackbar,
    _setEnableSnackbar,
    snackbarMessage,
    deleteProcess,
  } = useContext(RequestContext);
  const { userRole } = useContext(UserContext);

  const [idTypes, setIdTypes] = useState([]);
  const [isAlert, setAlert] = useState(false);
  const [alertMessage, setMessage] = useState({});
  const [validationError, setValidationError] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const [metadataFields, setMetadataFields] = useState([]);
  const [search, setSearch] = useState("");
  const [key, setKey] = useState("source");
  const [localEmails] = useState(window.localStorage.getItem('contacts')?.split(',') || []); 
  const [filenamesConfirmed, setFilenamesConfirmed] = useState(false);
  const [showDCPDatesWarningModal, setShowDCPDatesWarningModal] = useState(false);
  const [premiereDateConfirmation, setPremiereDateConfirmation] = useState(false);
  const [showFilenameWarningModal, setShowFilenameWarningModal] = useState(false);
  const checkRef = useRef(null);
  const dateRef = useRef(null);
  const ccRef = useRef(null);
  const [ccErrorState,setCCErrorState] = useState(false);

  useEffect(() => {
    loadParameters();
    setKey("source");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.href]);

  useEffect(() => {
    setIdTypes(_.get(jobType, "sourceDefinition", []));
  }, [jobType]);

  useEffect(() => {
    _.map(processes, (processValue) => {
      if (processValue.fileType === 'Streaming') {
        deleteProcess(processValue);
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processes]);

  useEffect(() => {
    let metadataFieldsValue = RequestUtils.getMetaDataField(
        _.get(sourceLocation, "metadata"),
        sourceLocation,
        itemList);
    setMetadataFields(metadataFieldsValue);
  }, [sourceLocation, itemList]);

  useEffect(() => {
    let fixedProcessType = JobUtils.extractSourceLocationProperty(
        sourceLocation,
        "processing.fixed"
    );
    if (fixedProcessType) {
      const processConfig = RequestUtils.getProcessFields(fixedProcessType[0]);
      let process =  {
        fileType: processConfig.group,
        profile: {
          description: processConfig.ref,
          code: processConfig.abbr
        }
      };
      _.map(processes, (processValue) => {
        updateProcess(processValue);
      });
      if (processes.length === 0) {
        addNewProcess(process);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sources]);

  //below function return status of disable state for fields
  const disableStatus = (controlId) => {
    switch (controlId) {
      case "required":
        return !JobUtils.isDrafting(status) || isEditing || showRequestForm;
      case "idType":
        return (
          isEditing ||
          jobType === null ||
          _.isEmpty(idTypes) ||
          !JobUtils.isDrafting(status) ||
          showRequestForm
        );
      case "note":
        let isEncodingType = _.get(sourceLocation, "type") === SourceLocations.MORPH_ENCODING;
        if (isEncodingType) {
          _setNotes("");
        }
        return !JobUtils.isDrafting(status)
            || showRequestForm
            || isEncodingType;
      default:
        return showRequestForm;
    }
  };

  const handleConfirmation = () => {
    const typeValue = _.get(alertMessage, "type");
    switch (typeValue) {
      case "IdType":
        let sourceType = _.find(
          idTypes,
          (source) => _.get(source, "type") === _.get(alertMessage, "value")
        );
        _setSourceLocation(sourceType);
        break;
      case "JobType":
        let selJobType = _.find(
          jobTypes,
          (jobTypeValue) => _.get(jobTypeValue, "jobType") === _.get(alertMessage, "value")
        );
        _setJobType(selJobType);
        setIdTypes(_.get(selJobType, "sourceDefinition", []));
        _setSourceLocation(null);
        break;
      default:
        break;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (checkRef.current.checkValidity()) {
      if (validateJob()) {
        requestDraft();
        _setShowRequestForm(true);
        if (premiereDatesWarning()) {
          setPremiereDateConfirmation(true);
        } else if(showDCPDatesWarning()){
          setShowDCPDatesWarningModal(true);
        }
      }
    } else {
      setKey("source");
      setTimeout(function () {
        checkRef.current.reportValidity();
      }, 200);
    }
    }
   
  const premiereDatesWarning = () => {
    if (type === RequestTypes.COPY || type === RequestTypes.REDO) {
      const isNoIdAvailable = sources.some((source) => _.get(source, 'assetIdType') === 'No ID Available')
      return (_.get(jobType, "jobType", "") === JobTypes.VIP_PRE_AIR || _.get(jobType, "jobType", "") === JobTypes.WB_SCREENERS)
          && _.get(sourceLocation, "type","") === SourceLocations.ASPERA
          && isNoIdAvailable
          && !premiereDateConfirmed;
    }
    return false;
  }

  const handleJobTypeChange = (e) => {
    e.preventDefault();
    let selJobType = _.find(
        jobTypes,
        (jobTypeValue) => _.get(jobTypeValue, "jobType") === e.target.value
    );
    if (!_.isEmpty(jobType) && !_.isEmpty(sourceLocation)) {
      setAlert(true);
      setMessage({
        type: "JobType",
        value: e.target.value,
        message: AlertMessage.JobType,
      });
    } else {
      _setJobType(selJobType);
      setIdTypes(_.get(selJobType, "sourceDefinition", []));
    }
    _setNotes("");
  }

  const handleSourceLocationChange = (e) => {
    e.preventDefault();
    let sourceType = _.find(
        idTypes,
        (source) => _.get(source, "type") === e.target.value
    );
    if (!_.isEmpty(sourceLocation)) {
      setAlert(true);
      setMessage({
        type: "IdType",
        value: e.target.value,
        message: AlertMessage.IdType,
      });
    } else {
      _setSourceLocation(sourceType);
    }
  }

  const validateJob = () => {
    setValidationError({});
    setStitchAssetNameError(false);
    setStitchingError(false);
    if (isStitch && _.get(sourceLocation, "allowStitching")) {
      if (!stitchAssetName) {
        setKey("stitch")
        setStitchAssetNameError(true);
        setValidationError({msg: ErrorMessages.STITCH_ASSET_NAME});
        return false;
      }
      if (stitchedKeys.length !== sources.length) {
        setKey("stitch")
        setStitchingError(true);
        setValidationError({msg: ErrorMessages.SOURCES_NOT_STITCHED});
        return false;
      }
    }
    let validatedJob = JobUtils.validateJob(
        jobType,
        isStitch ? [_.sortBy(sources,"key")[0]] : sources,
        processes,
        deliveries,
        deliveriesToSourceMapping
    );
    if (_.get(validatedJob, "noSource")) {
      setKey("source")
      setValidationError({msg: ErrorMessages.NO_SOURCE});
      return false;
    }
    _setUnMappedSources(_.get(validatedJob, "unMappedSources"));
    _setUnmappedDeliveryKeys(_.get(validatedJob, "unmappedDeliveryKeys"));
    if (_.size(_.get(validatedJob, "unMappedSources")) > 0) {
      setKey("delivery")
      setValidationError({msg: ErrorMessages.SOURCE_NOT_MAPPED});
      return false;
    }
    if (_.size(_.get(validatedJob, "unmappedDeliveryKeys")) > 0) {
      setKey("delivery")
      setValidationError({msg: ErrorMessages.DELIVERY_NOT_MAPPED});
      return false;
    }
    return true;
  };

  const onTabSelect = (tabKey) => {
    const PROCESSING = "processing";
    const DELIVERY = "delivery";
    setKey(tabKey);
    if (tabKey === PROCESSING && processes.length < 1) {
      _setShowProcessForm(true);
    } else if (tabKey === DELIVERY && deliveries.length < 1) {
      _setShowDeliveryForm(true);
    }
  };

  const openProcessForm = (e) => {
    e.preventDefault();
    if (!hasMultipleEcoProcesses()) {
      _setShowProcessForm(true);
    }
  }
  const hasMultipleEcoProcesses = () => {
    if (processes.length > 0) {
      for (let p of processes) {
        let profile = _.get(p, "profile");
        if (profile) {
          if (_.get(profile, "code") === ProcessorProfiles.WECO) {
            _setEcoProcessError(ErrorMessages.WECO_ERROR);
            return true;
          }
        }
      }
    }
    return false;
  }

  const filterInvalidEmails = (emails = []) => emails.filter(email => !!email && inputPattern.test(email));

  const onContactsUpdated = (newvalue, options) => {
      const emails = filterInvalidEmails(_.unionBy(options, _.toLower));
      window.localStorage.setItem('contacts', _.union(localEmails,emails).join(','));
      _setContacts(emails);
      if(filterInvalidEmails(options).length !== options.length){
        setCCErrorState(true);
        let errorValue= options.find(o=>emails.indexOf(o) === -1) || '';
        setSearch(errorValue);
        ccRef.current.getElementsByTagName('input')[0]?.setCustomValidity('Please Enter valid email address');
      }else{
        setSearch("");
        setCCErrorState(false);
        ccRef.current.getElementsByTagName('input')[0]?.setCustomValidity('')
      }
  }
  
const handleClickDatepickerIcon = () => {
  const datepickerElement = dateRef.current;
  datepickerElement.setFocus(true);
}

const handleModalOKClick = () => {
  if (showDCPDatesWarning()) {
    setDcpDateConfirmed(true);
    setShowDCPDatesWarningModal(false);
  } else if (premiereDatesWarning()) {
    setPremiereDateConfirmed(true);
    setPremiereDateConfirmation(false);
  } else if (!_.isEmpty(ecoProcessError)) {
    _setEcoProcessError("");
  } else if (showFilenameWarning()) {
    setFilenamesConfirmed(true);
    setShowFilenameWarningModal(false);
  }
}

const handleErrorPopup=()=>{
  if (!_.isEmpty(eventDeliveryFlag)){
    setEventDeliveryFlag({});
  }else if(importError){
    setImportError(false)
  }
}

const showDCPDatesWarning = () => {
  if (type === RequestTypes.COPY || type === RequestTypes.REDO) {
    const isDCPScreenerType = processes.some((process) => _.get(process, "screenerType", "") === ScreenerTypes.DCP);
    return _.get(jobType, "jobType") === JobTypes.EVENT_SCREENERS && isDCPScreenerType && !dcpDateConfirmed;
  }
  return false;
}

const showFilenameWarning = () => {
  return !filenamesConfirmed && sources.some((source) => {
    return JobUtils.checkInvalidFileName(jobType, source, stitchAssetName, isStitch);
  });
}

const getModalBodyMessage = () => {
  if (showDCPDatesWarning()) {
    for (let process of processes) {
      if (_.get(process, "screenerEncryptionType") === ScreenerEncryptionTypes.POST_HOUSE) {
        return Info.DKDM_DATES_WARNING
      } else if (_.get(process, "screenerEncryptionType") === ScreenerEncryptionTypes.THEATER_PROJECTOR) {
        return Info.KDM_DATES_WARNING;
      }
    }
  } else if (premiereDatesWarning()) {
    return Info.PREMIERE_DATE_WARNING;
  } else if (!_.isEmpty(ecoProcessError)) {
    return ecoProcessError;
  } else if (showFilenameWarning()) {
    return Info.FILENAME_WARNING;
  } else {
    return;
  }
}

const getErrorMessage=()=>{
  if (!_.isEmpty(eventDeliveryFlag)){
    return getAllowedMethod(eventDeliveryFlag)
  }else if(importError){
    return Info.IMPORT_WARNING;
  }else{
    return;
  }
}
  return display ? (
      <>
        <Row>
          <Col xs={6}>
            <Header headingText="New Request" mode="request"/>
          </Col>
          {showRequestForm ? (
              <Col xs={6} className="formActionButtons">
                <StyledDarkBlueButton id={"Request_modal_edit"} onClick={(e) => {
                  _setShowRequestForm(false);
                  setFilenamesConfirmed(false);
                }}>
                  Edit This Request
                </StyledDarkBlueButton>
                <StyledDarkBlueButton
                    id={"Request_Submit"}
                    disabled={hasInvalidAssets
                    || (needContentProtection && needContentProtection.length > 0 && (Object.keys(contentProtection).length !== needContentProtection.length))}
                    onClick={(e) => {
                      e.preventDefault();
                      // Info - file name warning was added as part of 974 and reverted later.
                      // if(showFilenameWarning()) {
                      //   setShowFilenameWarningModal(true);
                      // } else {
                      //   submitRequest();
                      // }
                      submitRequest();
                    }}
                >
                  {hasInvalidAssets ? "Invalid Assets" : "Submit Request"}
                </StyledDarkBlueButton>
              </Col>
          ) : (
            JobUtils.isDrafting(status) ? (
                _.size(sources) > 0 && JobUtils.showDelivery(jobType, processes)  ? (
                    <>
                      <Col xs={6} className="formActionButtons">
                        <StyledDarkBlueButton
                            id={"draft-request"}                            
                            type="submit"
                            onClick={(e) => {
                              e.preventDefault();
                              requestDraft();
                            }}
                        >
                          Save as Draft
                        </StyledDarkBlueButton>
                        <StyledDarkBlueButton
                            id={"submit-request"}                            
                            type="submit"
                            onClick={handleSubmit}
                        >
                          {" "}
                          View Request/Submit
                        </StyledDarkBlueButton>
                      </Col>
                    </>
                ) : null
            ) : (
                <>
                  <Col xs={6} className="formActionButtons">
                    <StyledDarkBlueButton
                        id={"update-job"}
                        type="submit"
                        disabled={hasInvalidAssets|| !_.isEmpty(validationError)}
                        onClick={(e) => {
                          e.preventDefault();
                          if (validateJob()) {
                            updateJob();
                          }
                        }}
                    >
                      Update Job
                    </StyledDarkBlueButton>
                  </Col>
                </>
            )
          )}
        </Row>
        {showRequestForm ? (
            <FormRequestSummary/>
        ) : (
          <>
            <Tabs className="tabs" activeKey={key} id="requestTabs" onSelect={onTabSelect} >
              <Tab tabClassName="tab" title="Source" eventKey="source">
                <Form id={"requestForm"} ref={checkRef} autoComplete='off'>
                  <Form.Row className="m-0 p-0">
                    <Form.Group
                        className="mr-4 p-0"
                        as={Col}
                        controlId="requestName"
                        xs={6}
                    >
                      <Form.Label className="formLabel">
                        {<FormLabelStyle label={"Request Name"} impField={true} />}
                      </Form.Label>
                      <Form.Control
                          className={
                            disableStatus("required") ? "formInputDisabled" : "formInput"
                          }
                          readOnly={isEditing}
                          autoComplete="off"
                          placeholder="Request Name"
                          disabled={disableStatus("required")}
                          // disabled={!JobUtils.isDrafting(status)}
                          onChange={(e) => {
                            e.preventDefault();
                            _setRequestName(e.target.value);
                          }}
                          value={requestName}
                          required
                      />
                    </Form.Group>
                    <Form.Group className="mr-4 p-0" as={Col} controlId="dueDate">
                      <Form.Label className="formLabel">
                        {<FormLabelStyle label={"Due Date"} impField={true} />}
                      </Form.Label>
                        <div className="datepickerCol">
                          <DatePicker
                              name="Due Date"
                              disabled={disableStatus("dueDate")}
                              onChange={(value) => {
                                _setDueDate(Moment(_.isNil(value) ? new Date() : value).tz("America/New_York").format("YYYY-MM-DDTHH:mm:ssZ"));
                              }}
                              selected={new Date(dueDate)}
                              minDate={new Date()}
                              className={disableStatus("dueDate") ? "formInputDisabled" : "formInput"}
                              required={true}
                              ref={dateRef}
                          >
                          </DatePicker>
                          <CalendarIcon
                            className="calendar_icon_form"
                            onClick = {handleClickDatepickerIcon}
                          />
                        </div>  
                    </Form.Group>
                    <Form.Group className="m-0 p-0" as={Col} controlId="dueTime">
                      <Form.Label className="formLabel">Due Time</Form.Label>
                      <Form.Control
                          as={Select}
                          disableUnderline={true}
                          displayEmpty
                          classes={{
                            disabled: "formSelectDisabled"
                          }}
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                            getContentAnchorEl: null,
                          }}
                          value={dueTime || ''}
                          onChange={(e) => {
                            e.preventDefault();
                            _setDueTime(e.target.value);
                          }}
                          disabled={disableStatus("dueTime")}
                          className={disableStatus("dueTime") ? "formInputSelectDisabled" : "formInputSelect"}
                      >
                        <MenuItem className="dropdownSelect" value="">
                          -----
                        </MenuItem>
                        <MenuItem className="dropdownSelect" value="Morning">
                          Morning
                        </MenuItem>
                        <MenuItem className="dropdownSelect" value="Afternoon">
                          Afternoon
                        </MenuItem>
                        <MenuItem className="dropdownSelect" value="Evening">
                          Evening
                        </MenuItem>
                      </Form.Control>
                    </Form.Group>
                  </Form.Row>
                  <Form.Row className="m-0 p-0 maxHeightFormRow">
                    <Form.Group className="mr-4 p-0" as={Col} controlId="jobType">
                      <Form.Label className="formLabel">
                        {<FormLabelStyle label={"Job Type"} impField={true} />}
                      </Form.Label>
                      <Form.Control
                          className={disableStatus("required") ? "formInputSelectDisabled" : "formInputSelect"}
                          required
                          as={Select}
                          disabled={disableStatus("required")}
                          // disabled={isEditing || !JobUtils.isDrafting(status)}
                          value={JobUtils.extractJobTypeProperty(jobType, "jobType") || ''}
                          disableUnderline={true}
                          displayEmpty
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                            getContentAnchorEl: null,
                          }}
                          classes={{
                            disabled: "formSelectDisabled"
                          }}
                          onChange={handleJobTypeChange}
                      >
                        <MenuItem className="dropdownSelect" value="">
                          -----
                        </MenuItem>
                        {_.map(jobTypes, (jobTypeValue, index) => {
                          return _.get(jobTypeValue, "active", true) ? (
                              <MenuItem
                                  className="dropdownSelect"
                                  key={index}
                                  value={_.get(jobTypeValue, "jobType")}
                              >
                                {_.get(jobTypeValue, "label")}
                              </MenuItem>
                          ) : null;
                        })}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group className="mr-4 p-0" as={Col} controlId="idType">
                      <Form.Label className="formLabel">
                        {<FormLabelStyle label={"Source Location"} impField={true} />}
                      </Form.Label>
                      <Form.Control
                          className={disableStatus("idType") ? "formInputSelectDisabled" : "formInputSelect"}
                          disabled={disableStatus("idType")}
                          as={Select}
                          required
                          value={JobUtils.extractSourceLocationProperty(
                              sourceLocation,
                              "type"
                          ) || ''}
                          displayEmpty
                          disableUnderline={true}
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                            transformOrigin: {
                              vertical: "top",
                              horizontal: "left",
                            },
                            getContentAnchorEl: null,
                          }}
                          classes={{
                            disabled: "formSelectDisabled"
                          }}
                          onChange={handleSourceLocationChange}
                      >
                        <MenuItem className="dropdownSelect" value="">
                          -----
                        </MenuItem>
                        {_.map(idTypes, (idType, index) => {
                          return _.get(idType, "active", true) && _.includes(_.get(idType, "role", PERMITTED_ROLES.DEFAULT_SOURCE_ROLES), userRole) ? (
                              <MenuItem
                                  className="dropdownSelect"
                                  key={index}
                                  value={_.get(idType, "type")}
                              >
                                {_.get(idType, "label")}
                              </MenuItem>
                          ) : null;
                        })}
                      </Form.Control>
                    </Form.Group>
                    <Form.Group className="m-0 p-0" as={Col} controlId="cc">
                      <Form.Label className="formLabel">
                        CC on Notifications
                      </Form.Label>
                       <Autocomplete
                          multiple                         
                          options={filterInvalidEmails(_.unionBy(localEmails, contacts, _.toLower)).filter(x => contacts.indexOf(x) ===-1)}
                          value={contacts}
                          inputValue={search}
                          classes={{
                            inputRoot: "formAutoCompleteEmailRoot",
                            input: "formAutoCompleteEmailInput",
                            listbox: "formList",
                            option: "formAutoCompleteOption",
                            popper: "formAutoCompleteEmailPopper",
                            focused: "formAutoCompleteEmailFocused"
                          }}
                          freeSolo
                          onChange={onContactsUpdated}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                            ))
                          }
                          renderInput={(params) => (
                              <TextField {...params} ref={ccRef}
                                InputProps={{ ...params.InputProps, autoComplete: "off"}}
                                onChange={(e) => {
                                  if(!e.target.value){
                                    setCCErrorState(false);
                                    ccRef.current.getElementsByTagName('input')[0]?.setCustomValidity('');
                                  }
                                  setSearch(e.target.value);
                                }}
                                error={ccErrorState}
                                helperText={ccErrorState ? 'Please Enter valid email address' : ''}
                                value={search}
                                variant="outlined"
                                placeholder="Add an E-mail" />
                          )}
                        />
                    </Form.Group>
                  </Form.Row>
                  <Form.Row className="m-0 p-0">
                    <Form.Group
                        className="m-0 p-0"
                        as={Col}
                        xs={6}
                        controlId="request_notes"
                    >
                      <Form.Label className="formLabel">Notes</Form.Label>
                      <Form.Control
                          as="textarea"
                          className={disableStatus("note") ? "formNoteDisabled" : "formNote"}
                          placeholder="Notes"
                          autoComplete="off"
                          disabled={disableStatus("note")}
                          value={notes}
                          onChange={(e) => {
                            e.preventDefault();
                            _setNotes(e.target.value);
                          }}
                      />
                    </Form.Group>
                  </Form.Row>
                  {_.get(sourceLocation, "allowStitching") && (
                    <Form.Row className="m-0 p-0">
                      <Form.Group className="m-0 p-0"
                                  controlId="stitch-checkbox">
                        <Form.Check
                            type="checkbox"
                            className="formCheckbox"
                            checked={isStitch}
                            onChange={() => setIsStitch(!isStitch)}
                            label={"Stitch source assets?"}
                        />
                      </Form.Group>
                    </Form.Row>
                  )}
                </Form>
                {!_.isEmpty(sourceLocation) ? (
                  <>
                    <Row className="mx-0 mt-4 mb-2">
                      <StyledBlueButton
                          type="submit"
                          className="mx-0"
                          hidden={!JobUtils.isDrafting(status)}
                          variant="contained"
                          onClick={(e) => {
                            e.preventDefault();
                            _setShowSourceForm(true);
                          }}>
                        <AddIcon></AddIcon><span>Add a Source</span>
                      </StyledBlueButton>
                      {_.get(sourceLocation, "hasBatchImport", false) && JobUtils.isDrafting(status) ? (
                          <ImportSources
                              keyCounter={_.size(sources)}
                              sourceLocation={sourceLocation}
                              onImportSources={(sourcesValue) => {
                                addNewSources(sourcesValue, null);
                              }}
                              metaData={metadataFields}
                              setImportError={setImportError}
                          />
                      ) : null}
                    </Row>
                    {showSourceForm ? (
                        <SourceForm metadataFields={metadataFields}/>
                    ) : null }
                    {!_.isEmpty(sources) ? (
                      <>
                        <Container fluid className="cardsContainer">
                          {_.map(sources, (source) => {
                            return (
                                <Source
                                    key={_.get(source, "key")}
                                    source={source}/>
                            );
                          })}
                        </Container>
                      </>
                    ) : null}
                  </>
                ) : null}
                {Boolean(anchorEl) ? (
                    <EmailPopper
                        anchor={anchorEl}
                        onClose={() => {
                          setAnchorEl(null);
                        }}
                    />
                      ) : null}
              </Tab>
              {isStitch ? (
                <Tab tabClassName="tab" title={"Stitch"} eventKey={"stitch"}>
                  <Stitch isDraft={JobUtils.isDrafting(status)}/>
                </Tab>
              ) : null}
              {!_.isEmpty(sourceLocation) && JobUtils.showProcessing(jobType, sources) ? (
                <Tab tabClassName="tab" title="Processing" eventKey="processing">
                  <Row className="processingRow">
                    <StyledBlueButton
                        hidden={!JobUtils.isDrafting(status)}
                        className="processingRowButton"
                        variant="contained"
                        onClick={openProcessForm}>
                      <AddIcon></AddIcon><span>Add a Process</span>
                    </StyledBlueButton>
                  </Row>
                  {showProcessForm ? (
                      <ProcessForm/>
                  ) : null }
                  {!_.isEmpty(processes) ? (
                    <>
                      <Container fluid className="cardsContainer">
                        {_.map(processes, (process) => {
                          return (
                              <Process
                                  hasMultipleEcoProcesses={hasMultipleEcoProcesses}
                                  key={_.get(process, "key")}
                                  process={process}/>
                          );
                        })}
                      </Container>
                    </>
                  ) : null}
                </Tab>
              ) : null}
              {_.get(jobType, "hasDelivery", true) && _.size(sources) > 0 && JobUtils.showDelivery(jobType, processes) ? (
                <Tab tabClassName="tab" title="Delivery" eventKey="delivery">
                  <Row style={{ marginBottom: "40px" }}>
                    <DndProvider backend={HTML5Backend}>
                      <Col xs={3}>
                        <SourceDrag/>
                      </Col>
                      <Col className="doubleArrowCol">
                        <DoubleArrow className="doubleArrow"/>
                      </Col>
                      <Col xs={8}>
                        <Delivery/>
                      </Col>
                    </DndProvider>
                  </Row>
                  {showDeliveryForm ? (
                      <DeliveryForm/>
                  ) : null }
                </Tab>
              ) : null}
            </Tabs>
            {!_.isEmpty(validationError) ? (
                <Snackbar
                    onClose={(event, reason) => {
                      setValidationError({});
                    }}
                    open={true}
                    autoHideDuration={5000}
                    message={_.get(validationError, "msg")}
                />
            ) : null}
            {isAlert ? (
                <AlertDialog
                    alertMessage={_.get(alertMessage, "message")}
                    isAlert={isAlert}
                    onClose={() => {
                      setAlert(false);
                    }}
                    onCancel={() => {
                      setMessage({});
                    }}
                    onConfirm={() => {
                      handleConfirmation();
                    }}
                />
            ) : null}
          </>
        )}
        <Modal
          className="modal warning-modal"
          show={!_.isEmpty(ecoProcessError) || showDCPDatesWarningModal || premiereDateConfirmation || showFilenameWarningModal }
          dialogClassName="modalDialog"
        >
          <Modal.Header className="modalHeader">
            <Modal.Title className="modalHeaderTitle">{!_.isEmpty(ecoProcessError) ? 'Submission Error' : 'Confirmation'}</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBody py-4">
            {getModalBodyMessage()}
          </Modal.Body>
          <Modal.Footer>
            <StyledBlueButton
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                handleModalOKClick();
              }}>
              OK
            </StyledBlueButton>
          </Modal.Footer>
        </Modal>
        <PopupModal
        show={!_.isEmpty(eventDeliveryFlag)||importError}
        title={'Error'}
        message={getErrorMessage()}
        onClose={(e) => {
          e.preventDefault();
          e.stopPropagation();          
          handleErrorPopup();
        }}
        />
        <Snackbar
        open={enableSnackbar}
        autoHideDuration={5000}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        onClose={() => {
          _setEnableSnackbar(false);
        }}
        disableWindowBlurListener={true}
        message={snackbarMessage}
        action={
          <CloseIcon
            id={"snackbar_close_icon"}
            onClick={() => {
              _setEnableSnackbar(false);
            }}
          />
        }
      />
      </>
  ) : (
      <span>{"Loading..."}</span>
  );
};

export default FormRequest;